export default __webpack_public_path__ + "static/media/check-circle.4f2b15f5.svg";